import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function Close(): React.ReactElement {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.2222 10L20 2.22222L17.7778 0L10 7.77778L2.22222 0L5.2982e-07 2.22222L7.77778 10L0 17.7778L2.22222 20L10 12.2222L17.7778 20L20 17.7778L12.2222 10Z" />
    </svg>
  );
}
